module.exports = __webpack_public_path__ + "static/media/27.0c6a3269.jpg";